import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom"; 
import "../style/Navbar.scss";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [hoveredLink, setHoveredLink] = useState(null);

  const location = useLocation();
  const pathname = location.pathname;

  const navRef = useRef(null);
  const indicatorRef = useRef(null);

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/services", label: "Services" },
    { href: "/Showcase", label: "Projects" },
    { href: "/AboutUs", label: "About" },
    { href: "/contact", label: "Contact" },
  ];

  useEffect(() => {
    setActiveLink(pathname);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "unset";
    return () => { document.body.style.overflow = "unset"; };
  }, [isMenuOpen]);

  useEffect(() => {
    const linkId = hoveredLink || activeLink;
    if (linkId && indicatorRef.current) {
      const activeElement = document.getElementById(`nav-link-${linkId}`);
      if (activeElement) {
        const { offsetLeft, offsetWidth } = activeElement;
        indicatorRef.current.style.width = `${offsetWidth}px`;
        indicatorRef.current.style.transform = `translateX(${offsetLeft}px)`;
      }
    }
  }, [hoveredLink, activeLink]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <nav 
        ref={navRef}
        className={`nav ${isScrolled ? "scrolled" : ""} ${isMenuOpen ? "menuOpen" : ""}`}
      >
        <div className="container-navbarr">
          <Link to="/" className="logo" onClick={closeMenu}>
            <div className="logoWrapper">
              <img
                src="/logo/logo evas avec le nom.png" 
                alt="Logo"
                className="logoImage"
              />
              <div className="logoGlow"></div>
            </div>
          </Link>

          <div className="desktopMenu">
            <div className="navLinks">
              <div className="indicator" ref={indicatorRef}></div>
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  id={`nav-link-${link.href}`}
                  to={link.href}
                  className={`navLink ${activeLink === link.href ? "active" : ""}`}
                  onMouseEnter={() => setHoveredLink(link.href)}
                  onMouseLeave={() => setHoveredLink(null)}
                >
                  <span className="linkText">{link.label}</span>
                  <span className="linkNumber"></span> 
                </Link>
              ))}
            </div>

            <div className="cta">
              <Link to="/contact" className="primaryButton">
                <span className="buttonText">Start Project</span>
                <span className="buttonIcon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 16L16 4M16 4H8M16 4V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </span>
                <span className="buttonGlow"></span>
              </Link>
            </div>
          </div>

          <button className={`menuButton ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
            <div className="menuButtonInner">
              <span className="menuLine"></span>
              <span className="menuLine"></span>
              <span className="menuLine"></span>
            </div>
          </button>
        </div>
      </nav>

      <div className={`mobileMenu ${isMenuOpen ? "active" : ""}`}>
        <div className="mobileMenuBackground">
          <div className="mobileMenuGradient"></div>
        </div>

        <div className="mobileMenuContent">
          <div className="mobileLinks">
            {navLinks.map((link, index) => (
              <Link
                key={link.href}
                to={link.href}
                className={`mobileLink ${activeLink === link.href ? "active" : ""}`}
                onClick={closeMenu}
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                <span className="mobileLinkNumber">
                  {(index + 1).toString().padStart(2, '0')}
                </span>
                <span className="mobileLinkText">{link.label}</span>
                <span className="mobileLinkArrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5 19L19 5M19 5H9M19 5V15" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}